import { FC } from "react"
import { Control, FieldValues, FieldErrors, FieldError } from "react-hook-form"
import { FormbuilderInput } from "../formbuilder-input"

interface DateFormProps {
    control: Control<FieldValues, any>
    errors: FieldErrors<FieldValues>
}

export const DateForm: FC<DateFormProps> = ({ control, errors }) => {
    return (
        <>
            <FormbuilderInput
                control={control}
                label={"Минимальная дата"}
                id={"min_date"}
                error={errors['min_date'] as FieldError}
                type="datepicker"
                required={true}
                placeholder="Введите минимальную дату"
            />
            <FormbuilderInput
                control={control}
                label={"Максимальная дата"}
                id={"max_date"}
                error={errors['max_date'] as FieldError}
                type="datepicker"
                required={true}
                placeholder="Введите максимальную дату"
            />
        </>
    )
}